import { enqueueSnackbar } from 'notistack';
import axiosInstance, { endpoints } from 'src/utils/axios';

export async function getAllTrainee(userID) {
  // console.log(`Envoi d'une requête pour récupérer les stagiaires de l'utilisateur avec ID ${userID}` );
  try {
    const response = await axiosInstance.get(`${endpoints.trainee.getAll}/${userID}/trainees`);
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}

export async function deleteTrainee(traineeObject) {
  // console.log("Envoi d'une requête pour supprimer  l'utilisateur:", traineeObject);
  try {
    const response = await axiosInstance.post(endpoints.trainee.delete, {...traineeObject, });
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}
